import { render, staticRenderFns } from "./vsChip.vue?vue&type=template&id=02e82a4c&lang=html&"
import script from "./vsChip.vue?vue&type=script&lang=js&"
export * from "./vsChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsChip.vue"
export default component.exports